var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const Teacher = (_a) => {
    var { color = '#454957', fill = 'none', width = 24, height = 24 } = _a, props = __rest(_a, ["color", "fill", "width", "height"]);
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: fill, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10.0495 2.53001L4.02953 6.46001C2.09953 7.72001 2.09953 10.54 4.02953 11.8L10.0495 15.73C11.1295 16.44 12.9095 16.44 13.9895 15.73L19.9795 11.8C21.8995 10.54 21.8995 7.73001 19.9795 6.47001L13.9895 2.54001C12.9095 1.82001 11.1295 1.82001 10.0495 2.53001Z", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M5.63109 13.08L5.62109 17.77C5.62109 19.04 6.60109 20.4 7.80109 20.8L10.9911 21.86C11.5411 22.04 12.4511 22.04 13.0111 21.86L16.2011 20.8C17.4011 20.4 18.3811 19.04 18.3811 17.77V13.13", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M21.3984 15V9", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default Teacher;
